<template>
  <div class="tv360-home">
    <!-- loading -->
    <template v-if="loadingService">
      <metfone-loading />
    </template>

    <!-- services history -->

    <template v-else-if="isShowContentTV360 === 'history'">
      <loading :show-loading="showHistoryLoading || historyRefreshing" />

      <template
        v-if="historyLoading && (!tv360History || tv360History.length === 0)"
      >
        <metfone-loading />
      </template>
      <!-- Top refresh loader (show full metfone-loading while refreshing) -->
      <!-- 
      <div v-if="historyRefreshing" class="tv360-history-refresh-icon">
        <metfone-loading />
      </div>
      -->

      <van-pull-refresh
        v-model:refreshing="historyRefreshing"
        @refresh="onRefreshHistory"
        @touchstart.passive="onTouchStart"
        @touchmove.passive="onTouchMove"
        @touchend.passive="onTouchEnd"
      >
        <van-list
          v-model:loading="historyLoading"
          :finished="historyFinished"
          loading-text=""
          @load="onLoadMoreHistory"
          :immediate-check="true"
          :offset="20"
        >
          <template #loading>
            <div
              v-if="
                !(
                  historyLoading &&
                  (!tv360History || tv360History.length === 0)
                )
              "
              style="display: flex; justify-content: center; padding: 8px 0"
            >
              <van-loading color="#C41627" />
            </div>
          </template>
          <template #finished>
            <div style="height: 8px"></div>
          </template>
          <div
            v-for="(h, idx) in tv360History"
            :key="idx"
            style="margin-bottom: 10px"
          >
            <HistoryItem
              :data="h"
              @sync="onSyncHistory"
              @reload="onRefreshHistory"
              @sync-failed="onSyncFailed"
            />
          </div>
        </van-list>

        <div
          v-if="!historyLoading && (!tv360History || tv360History.length === 0)"
          style="padding: 16px; text-align: center; color: #999"
        >
          <data-notify :content="$t('tv360.not_histories')" />
        </div>
      </van-pull-refresh>
    </template>

    <!-- services list -->
    <template
      v-else-if="
        tv360Services && tv360Services.length > 0 && checkArray(tv360Services)
      "
    >
      <div
        v-for="(value, index) in tv360Services"
        :key="index"
        style="margin-bottom: 10px"
      >
        <HomeItem
          :package_active="itemActive"
          :data="value"
          @click="handleShowDetail(value)"
        />
      </div>
    </template>

    <!-- one service as object -->
    <template
      v-else-if="
        tv360Services &&
        !checkArray(tv360Services) &&
        !isObjectEmpty(tv360Services)
      "
    >
      <div style="margin-bottom: 10px">
        <HomeItem
          :data="tv360Services"
          @click="handleShowDetail(tv360Services)"
        />
      </div>
    </template>

    <!-- services history -->

    <!-- Popup confirm purchase -->
    <ConfirmPurchaseTV360
      :item="item"
      id="confirmpurchasetv360"
      v-model:is-show.sync="showDetail"
      v-if="showDetail"
    />
    <!-- Processing dialog shown when user triggers sync history -->
    <ProcessingTV360Dialog
      v-model:is-show="showProcessingDialog"
      :title="titleProcessingDialog"
      :message="contentProcessingDialog"
      @close="handleCloseProcessingDialog"
    />
  </div>
</template>

<script src="./index.js"></script>

<style src="./index.css" lang="css" scoped></style>
<style scoped>
.tv360-history-refresh-icon {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 8px;
  z-index: 20;
  pointer-events: none; /* spinner shouldn't block interactions */
}
.tv360-history-refresh-icon > div {
  pointer-events: auto; /* allow inner van-loading if needed */
}
.tv360-home {
  position: relative;
}
</style>
